export enum DataProtectionAgreementTranslations {
  dataProtectionAgreementHtml = 'dataProtectionAgreement.dataProtectionAgreementHtml',
}
